<template>
  <ul class="categoryChips">
    <li v-for="(chip, i) in photos" :key="i">
      <p class="chip selectable"
         :class="{ 'selected': selected.includes(i) }"
         @click="clickCategory(i, $event)">{{ sectionList[i]['name'] }}</p>
    </li>
  </ul>
  <div v-for="(photo, j) in photos" :key="j">
    <section id="{{ sectionList[j]['id'] }}" v-if="isShow(j)">
      <h2>{{ photo[0].category_name }}<span class="sub">{{ photo.length }}件</span></h2>
      <slide-photos :photos=photo></slide-photos>
    </section>
  </div>
</template>
<script>

export default {
  props: {
    photos: Object,
    required: false
  },
  data() {
    return {
      sectionList: {
        1: { id: 'introspection', name: '内観' },
        2: { id: 'exterior', name: '外観' },
        3: { id: 'course', name: 'コース' },
        4: { id: 'cooking', name: '料理' },
        5: { id: 'drink', name: 'ドリンク' },
        0: { id: 'other', name: 'その他' }
      },
      selected: []
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.selected = Object.keys(this.photos)
    },
    clickCategory(index, e) {
      e.target.blur()
      if (!this.selected.includes(index)) {
        this.selected.push(index)
      } else {
        this.selected = this.selected.filter(v => {
          return v !== index
        })
      }
    },
    isShow(index) {
      return (this.selected.length > 0) ? this.selected.includes(index) : true
    }
  }
}
</script>
